import { render, staticRenderFns } from "./l-main.vue?vue&type=template&id=1d50ccce&scoped=true&"
import script from "./l-main.vue?vue&type=script&lang=js&"
export * from "./l-main.vue?vue&type=script&lang=js&"
import style0 from "./l-main.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./l-main.vue?vue&type=style&index=1&id=1d50ccce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d50ccce",
  null
  
)

export default component.exports